import { authApi } from "@/modules/auth";
import { ROUTE_PATHS } from "@/shared/constants/route-paths";
import { STORAGE_KEYS } from "@/shared/constants/storage-keys";
import { webSessionStorage } from "@/shared/lib/storage";

export type ConnectProvider = "qq" | "wechat";

interface ConnectIntent {
  userId: string;
  provider: ConnectProvider;
}

export function accountConnectUrl(provider: ConnectProvider) {
  const url = new URL(ROUTE_PATHS.ACCOUNT_CONNECT, window.location.origin);
  url.searchParams.set("provider", provider);
  return url.toString();
}

export function readConnectIntent() {
  return webSessionStorage.getItem<ConnectIntent>(STORAGE_KEYS.accountConnectIntent);
}

export function clearConnectIntent() {
  webSessionStorage.removeItem(STORAGE_KEYS.accountConnectIntent);
}

export async function beginAccountConnection(provider: ConnectProvider, userId: string) {
  const next = accountConnectUrl(provider);
  const response = provider === "qq"
    ? await authApi.getQQConnectLink({ next })
    : await authApi.getWechatQRCodeLink({ next });
  webSessionStorage.setItem(STORAGE_KEYS.accountConnectIntent, { userId, provider }, 10 * 60 * 1000);
  window.location.assign(response.url);
}
